import styled from 'styled-components/macro';
import { fontSize } from '../../styles/mixins';

export const ErrorTitleWrapper = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.primaryColor};
  * {
  }
  i {
    position: relative;
    ${fontSize(30)};
    margin-right: 15px;
  }
`;

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.colorText};
  ${fontSize(14)};
  text-align: center;
  margin: 20px 0;
`;
